import type { Database, Json } from './supabase'; // Assuming Json is defined here or elsewhere
import type { PaginationParams } from '@/utils/pagination/paginationUtils'; // Import needed types

// --- Moved from poemService.ts ---

/**
 * Options for querying poems with filtering capabilities
 */
export interface PoemQueryOptions {
  /**
   * Whether to include archived poems in results
   * When false or undefined, excludes archived poems
   */
  includeArchived?: boolean;
  
  /**
   * Optional ordering parameters
   */
  order?: {
    column: string;
    direction: 'asc' | 'desc';
  };
}

/**
 * Extended query options for paginated poem queries
 */
export interface PaginatedPoemQueryOptions extends PaginationParams {
  /**
   * Whether to include archived poems in results
   * When false or undefined, excludes archived poems
   */
  includeArchived?: boolean;
}

// --- Moved from highlightGenerationService.ts ---

/**
 * Enum representing the supported API providers for highlight generation.
 */
export enum ApiProvider {
    ANTHROPIC = 'anthropic',
    OPENAI = 'openai',
}

// --- Add other shared types/enums/interfaces here as needed --- 